// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ArchiverController from "./archiver_controller"
application.register("archiver", ArchiverController)

import ArrangeController from "./arrange_controller"
application.register("arrange", ArrangeController)

import AttributeController from "./attribute_controller"
application.register("attribute", AttributeController)

import AutoHiderController from "./auto_hider_controller"
application.register("auto-hider", AutoHiderController)

import BlowerController from "./blower_controller"
application.register("blower", BlowerController)

import CancelController from "./cancel_controller"
application.register("cancel", CancelController)

import CheckController from "./check_controller"
application.register("check", CheckController)

import CheckDisableController from "./check_disable_controller"
application.register("check-disable", CheckDisableController)

import CheckEnableController from "./check_enable_controller"
application.register("check-enable", CheckEnableController)

import CheckHideController from "./check_hide_controller"
application.register("check-hide", CheckHideController)

import CheckUsabilityOppositeController from "./check_usability_opposite_controller"
application.register("check-usability-opposite", CheckUsabilityOppositeController)

import CheckboxController from "./checkbox_controller"
application.register("checkbox", CheckboxController)

import ClassController from "./class_controller"
application.register("class", ClassController)

import ClientsController from "./clients_controller"
application.register("clients", ClientsController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CollectorsController from "./collectors_controller"
application.register("collectors", CollectorsController)

import ContactsController from "./contacts_controller"
application.register("contacts", ContactsController)

import ContainerClassController from "./container_class_controller"
application.register("container-class", ContainerClassController)

import ControlsController from "./controls_controller"
application.register("controls", ControlsController)

import CookiesController from "./cookies_controller"
application.register("cookies", CookiesController)

import CountController from "./count_controller"
application.register("count", CountController)

import CrudController from "./crud_controller"
application.register("crud", CrudController)

import CustomDescriptionController from "./custom_description_controller"
application.register("custom-description", CustomDescriptionController)

import DatatableController from "./datatable_controller"
application.register("datatable", DatatableController)

import DatePickerController from "./date_picker_controller"
application.register("date-picker", DatePickerController)

import DefaultController from "./default_controller"
application.register("default", DefaultController)

import DisablesController from "./disables_controller"
application.register("disables", DisablesController)

import DisablesOnLoadController from "./disables_on_load_controller"
application.register("disables-on-load", DisablesOnLoadController)

import DismissController from "./dismiss_controller"
application.register("dismiss", DismissController)

import DisplayController from "./display_controller"
application.register("display", DisplayController)

import DisplayTreeController from "./display_tree_controller"
application.register("display-tree", DisplayTreeController)

import DocOptionController from "./doc_option_controller"
application.register("doc-option", DocOptionController)

import EffectsController from "./effects_controller"
application.register("effects", EffectsController)

import EmoController from "./emo_controller"
application.register("emo", EmoController)

import EmoTwoOptionsController from "./emo_two_options_controller"
application.register("emo-two-options", EmoTwoOptionsController)

import EnablesController from "./enables_controller"
application.register("enables", EnablesController)

import EnablesNodesController from "./enables_nodes_controller"
application.register("enables-nodes", EnablesNodesController)

import EuFanController from "./eu_fan_controller"
application.register("eu-fan", EuFanController)

import EuropeXventController from "./europe_xvent_controller"
application.register("europe-xvent", EuropeXventController)

import ExclusionsController from "./exclusions_controller"
application.register("exclusions", ExclusionsController)

import ExclusiveController from "./exclusive_controller"
application.register("exclusive", ExclusiveController)

import FilterController from "./filter_controller"
application.register("filter", FilterController)

import FinalizeController from "./finalize_controller"
application.register("finalize", FinalizeController)

import FlexController from "./flex_controller"
application.register("flex", FlexController)

import FormsController from "./forms_controller"
application.register("forms", FormsController)

import GsController from "./gs_controller"
application.register("gs", GsController)

import GsDischargeController from "./gs_discharge_controller"
application.register("gs-discharge", GsDischargeController)

import GsFansController from "./gs_fans_controller"
application.register("gs-fans", GsFansController)

import GsHvsController from "./gs_hvs_controller"
application.register("gs-hvs", GsHvsController)

import GsInletsController from "./gs_inlets_controller"
application.register("gs-inlets", GsInletsController)

import GsOptionsController from "./gs_options_controller"
application.register("gs-options", GsOptionsController)

import GspController from "./gsp_controller"
application.register("gsp", GspController)

import HandteEmExpertOneController from "./handte_em_expert_one_controller"
application.register("handte-em-expert-one", HandteEmExpertOneController)

import HandteEmProfiOneController from "./handte_em_profi_one_controller"
application.register("handte-em-profi-one", HandteEmProfiOneController)

import HandteFansController from "./handte_fans_controller"
application.register("handte-fans", HandteFansController)

import HandteOilExpertController from "./handte_oil_expert_controller"
application.register("handte-oil-expert", HandteOilExpertController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HideController from "./hide_controller"
application.register("hide", HideController)

import HideSpecificController from "./hide_specific_controller"
application.register("hide-specific", HideSpecificController)

import HighlightController from "./highlight_controller"
application.register("highlight", HighlightController)

import InitialsController from "./initials_controller"
application.register("initials", InitialsController)

import InletsController from "./inlets_controller"
application.register("inlets", InletsController)

import KeyStealerController from "./key_stealer_controller"
application.register("key-stealer", KeyStealerController)

import LinkCheckController from "./link_check_controller"
application.register("link-check", LinkCheckController)

import LinkDisableController from "./link_disable_controller"
application.register("link-disable", LinkDisableController)

import LinkEnableController from "./link_enable_controller"
application.register("link-enable", LinkEnableController)

import LinkHideController from "./link_hide_controller"
application.register("link-hide", LinkHideController)

import LinkMessageController from "./link_message_controller"
application.register("link-message", LinkMessageController)

import LinkShowController from "./link_show_controller"
application.register("link-show", LinkShowController)

import LinkToggleController from "./link_toggle_controller"
application.register("link-toggle", LinkToggleController)

import LinkUncheckController from "./link_uncheck_controller"
application.register("link-uncheck", LinkUncheckController)

import ListController from "./list_controller"
application.register("list", ListController)

import LocationsController from "./locations_controller"
application.register("locations", LocationsController)

import LoggerController from "./logger_controller"
application.register("logger", LoggerController)

import MediaAreaController from "./media_area_controller"
application.register("media-area", MediaAreaController)

import MessageController from "./message_controller"
application.register("message", MessageController)

import ModelController from "./model_controller"
application.register("model", ModelController)

import MultiplesController from "./multiples_controller"
application.register("multiples", MultiplesController)

import MutuallyExclusiveController from "./mutually_exclusive_controller"
application.register("mutually-exclusive", MutuallyExclusiveController)

import OptionsController from "./options_controller"
application.register("options", OptionsController)

import OrdersController from "./orders_controller"
application.register("orders", OrdersController)

import PageController from "./page_controller"
application.register("page", PageController)

import PartsController from "./parts_controller"
application.register("parts", PartsController)

import ProfiFanController from "./profi_fan_controller"
application.register("profi-fan", ProfiFanController)

import ProjectDocsController from "./project_docs_controller"
application.register("project-docs", ProjectDocsController)

import QuadPulseController from "./quad_pulse_controller"
application.register("quad-pulse", QuadPulseController)

import QuadPulseOptionController from "./quad_pulse_option_controller"
application.register("quad-pulse-option", QuadPulseOptionController)

import QuickHelpController from "./quick_help_controller"
application.register("quick-help", QuickHelpController)

import QuoteElementController from "./quote_element_controller"
application.register("quote-element", QuoteElementController)

import RadioController from "./radio_controller"
application.register("radio", RadioController)

import RadioGroupController from "./radio_group_controller"
application.register("radio-group", RadioGroupController)

import ScrollController from "./scroll_controller"
application.register("scroll", ScrollController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import SelectableController from "./selectable_controller"
application.register("selectable", SelectableController)

import ServicesController from "./services_controller"
application.register("services", ServicesController)

import ShowController from "./show_controller"
application.register("show", ShowController)

import ShowSpecificController from "./show_specific_controller"
application.register("show-specific", ShowSpecificController)

import SimpleDisableController from "./simple_disable_controller"
application.register("simple-disable", SimpleDisableController)

import SimpleToggleController from "./simple_toggle_controller"
application.register("simple-toggle", SimpleToggleController)

import SolenoidsController from "./solenoids_controller"
application.register("solenoids", SolenoidsController)

import SpecialFanController from "./special_fan_controller"
application.register("special-fan", SpecialFanController)

import SpinnerController from "./spinner_controller"
application.register("spinner", SpinnerController)

import StandardFeatureController from "./standard_feature_controller"
application.register("standard-feature", StandardFeatureController)

import StingerSelectionController from "./stinger_selection_controller"
application.register("stinger-selection", StingerSelectionController)

import SubmitController from "./submit_controller"
application.register("submit", SubmitController)

import TableFilterController from "./table_filter_controller"
application.register("table-filter", TableFilterController)

import TableSorterController from "./table_sorter_controller"
application.register("table-sorter", TableSorterController)

import TechServiceSpecialsController from "./tech_service_specials_controller"
application.register("tech-service-specials", TechServiceSpecialsController)

import TerritoriesController from "./territories_controller"
application.register("territories", TerritoriesController)

import TextController from "./text_controller"
application.register("text", TextController)

import TitleController from "./title_controller"
application.register("title", TitleController)

import TogglesController from "./toggles_controller"
application.register("toggles", TogglesController)

import UncheckController from "./uncheck_controller"
application.register("uncheck", UncheckController)

import UncheckDisableController from "./uncheck_disable_controller"
application.register("uncheck-disable", UncheckDisableController)

import UsabilityController from "./usability_controller"
application.register("usability", UsabilityController)

import UsabilityGroupController from "./usability_group_controller"
application.register("usability-group", UsabilityGroupController)

import UseForBothController from "./use_for_both_controller"
application.register("use-for-both", UseForBothController)

import UserFanController from "./user_fan_controller"
application.register("user-fan", UserFanController)

import UserTranslationController from "./user_translation_controller"
application.register("user-translation", UserTranslationController)

import UsersController from "./users_controller"
application.register("users", UsersController)

import ValidateController from "./validate_controller"
application.register("validate", ValidateController)

import VisibilityController from "./visibility_controller"
application.register("visibility", VisibilityController)

import VortexesController from "./vortexes_controller"
application.register("vortexes", VortexesController)

import WarningController from "./warning_controller"
application.register("warning", WarningController)

import WizardController from "./wizard_controller"
application.register("wizard", WizardController)

import XfloInletsController from "./xflo_inlets_controller"
application.register("xflo-inlets", XfloInletsController)

import XventController from "./xvent_controller"
application.register("xvent", XventController)

import ZipCodesController from "./zip_codes_controller"
application.register("zip-codes", ZipCodesController)
